import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-sports',
  templateUrl: './employee-sports.component.html',
  styleUrls: ['./employee-sports.component.scss']
})
export class EmployeeSportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
